module.exports = __webpack_public_path__ + "static/base-github-70e8e20df1aeb6ff4c02b10d2ce23449.png";